import { disableOuibounceForNormal } from '../utils/func.js'
import { btnLoadingStart, btnLoadingDone } from '../components/loading.js'
import { cloneSurvey } from '../utils/survey-btn-effect.js'
import { __sendVisit, __visit } from '../components/send-visit.js'
import ieDetect from '../utils/ie-detect.js'
import { getCookie, setCookie } from '../utils/cookie.js'
// import { saveInfoToCookie } from '../components/save-info-to-cookie'
// import Swal from 'sweetalert2'
import { swalOption } from '../components/swal-opt.js'
import prepareKoNamePost from '../utils/prepareKoNamePost.js'
import { stopCountDown } from '../components/init-checkout-timer.js'
import detectMobileWidth from '../utils/detectMobileWidth.js'
import { string } from 'yargs'
import { setShippingBillingValidationRules } from './setValidationRules'
import Swal from 'sweetalert2'
import { hideLoadingModal, showLoadingModal } from '../transitions/show-loading-modal.js'
import { saveInfoToCookie } from '../components/save-info-to-cookie.js'

// export let resultOrderEid
export function frontendErrorToShow(errorElement: any) {
	$('#error-msg-holder').empty()
	// var errorElement = $('#order-payment-form-left').find('.has-error em.error')
	// return new Promise(function (resolve, reject) {
	$.each(errorElement, (i, v) => {
		const errorText = $(v).text()
		const errorMsg = `<li data-error-key=${String(i)}>${errorText}</li>`
		$('#error-msg-holder').append(errorMsg)
	})
}
type ErrorProp = { [k: string]: string }
type MyObjProp = {
	field: { error: string }
	message: { error: ErrorProp[] }
	orderId: string
	title: string
}

export function preparErrorToShow(myObj: MyObjProp, error: ErrorProp[]) {
	return new Promise<void>((resolve, _) => {
		$.each(error, (key, value) => {
			const errorMsg = '<li data-errorkey=' + key + '>' + value + '</li>'
			$('#error-msg-holder').append(errorMsg)
			// errorKey = key
		})

		if (myObj.field == undefined) {
		} else {
			const errorInputName = myObj.field.error
			// console.info(`myObj.field.error = ${myObj.field.error}`)

			$.each(errorInputName, (key, value) => {
				const errorField = $('[name="' + value + '"]')
				errorField.attr('data-error-key', key).addClass('error-input-item')
				errorField.parent().removeClass('has-success').addClass('has-error')
			})
		}

		resolve()
	})
}

export function preparErrorToShowScalp(myObj: MyObjProp, error: ErrorProp[]) {
	return new Promise<void>((resolve, _) => {
		if (myObj.title)
			$('#error-msg-title-seating-chart-anti-scalping').text(myObj.title)

		$.each(error, (key, value) => {
			const errorMsg = '<li data-errorkey=' + key + '>' + value + '</li>'
			$('#error-msg-holder-anti-scalping').append(errorMsg)
		})

		if (myObj.field == undefined) {
		} else {
			const errorInputName = myObj.field.error
			$.each(errorInputName, (key, value) => {
				const errorField = $('[name="' + value + '"]')
				errorField.attr('data-error-key', key).addClass('error-input-item')
				errorField.parent().removeClass('has-success').addClass('has-error')
			})
		}
		resolve()
	})
}

export function showErrorInField(myObj: MyObjProp, error: ErrorProp[]) {
	return new Promise<string>((resolve, reject) => {
		let errorGoBackToStep: string
		if (myObj.field == undefined) {
			reject()
		} else {
			const errorFields = $('#order-payment-form').find('.error-input-item')
			// debugger;
			$.each(errorFields, (index, field) => {
				const errorKeyNum = $(field).attr('data-error-key')
				const inputWrapper = $(field).parent()

				$.each(error, (key, value) => {
					// @ts-ignore
					if (errorKeyNum && errorKeyNum == key) {
						const html = '<div class="error help-block">' + value + '</div>'
						inputWrapper.find('.help-block').remove()
						inputWrapper.append(html)
					}
				})

				if (index == 0) {
					const mobileErrorPage = $(field).parents('[fp-mobile-page="true"]')
					// @ts-ignore
					errorGoBackToStep = mobileErrorPage.attr('fp-mobile-error-mark-group')
				}

				$(field).focus(() => {
					inputWrapper.find('div').remove()
				})
			})
			// @ts-ignore
			resolve(errorGoBackToStep)
		}
	})
}

export function popupError(errorGoBackToStep: number | undefined | string) {

	if (detectMobileWidth()) {
		$('#error-msg-close-btn').click((e) => {
			// console.log('test here to seen in mobile!');
			console.info(`errorGoBackToStep is ${errorGoBackToStep}`)
			if (errorGoBackToStep === undefined) {
				window.curStep.step = 3
				window.curStep.page = 3
			} else if (errorGoBackToStep == 3) {
				if (window.giftCardCheckout) {
					window.curStep.step = 2
					window.curStep.page = 2
				} else {
					window.curStep.step = 3
					window.curStep.page = errorGoBackToStep
				}
			} else {
				window.curStep.step = 2
				window.curStep.page = errorGoBackToStep
			}

			// console.info(`window.curStep.step: ${window.curStep.step}`)
			// console.info(`window.curStep.page: ${window.curStep.page}`)

			window.updateUI()
		})
	}
}

export function popupErrorScalp(errorGoBackToStep: number | undefined | string) {
	if (detectMobileWidth()) {
		$('#error-msg-close-btn-anti-scalping').click((e) => {
			console.info(`errorGoBackToStep is ${errorGoBackToStep}`)
			if (errorGoBackToStep === undefined) {
				window.curStep.step = 3
				window.curStep.page = 3
			} else if (errorGoBackToStep == 3) {
				if (window.giftCardCheckout) {
					window.curStep.step = 2
					window.curStep.page = 2
				} else {
					window.curStep.step = 3
					window.curStep.page = errorGoBackToStep
				}
			} else {
				window.curStep.step = 2
				window.curStep.page = errorGoBackToStep
			}
			window.updateUI()
		})
	}
}

export function errorLoading() {
	$('#error-msg-holder').empty()
}

function errorModal() {
	// @ts-ignore
	$('#error-msg-holder-wrapper').modal('show')
		.on('hidden.bs.modal', () => {
			btnLoadingDone('#button-place-order')
		})
}

function errorModalScalp() {
	// @ts-ignore
	$('#error-msg-holder-wrapper-anti-scalping').modal('show')
		.on('hidden.bs.modal', () => {
			btnLoadingDone('#button-place-order')
		})
}

export async function errorUpdateUI(myObj: MyObjProp) {
	try {
		await errorLoading()
		const { error } = myObj.message
		await preparErrorToShow(myObj, error)
		await errorModal()
		const errorGoBackToStep = await showErrorInField(myObj, error)
		// await btnLoadingDone('#button-place-order')
		popupError(errorGoBackToStep)
	} catch (_error) {
		console.info(`catch error in function errorUpdateUI: ${_error}`)
	}
}

export function errorLoadingScalp() {
	$('#error-msg-holder-anti-scalping').empty()
	$('#error-msg-title-seating-chart-anti-scalping').empty()
}

export async function errorUpdateUIScalp(myObj: MyObjProp) {
	try {
		await errorLoadingScalp()
		const { error } = myObj.message
		await preparErrorToShowScalp(myObj, error)
		await errorModalScalp()
		const errorGoBackToStep = await showErrorInField(myObj, error)
		// await btnLoadingDone('#button-place-order')
		popupError(errorGoBackToStep)
	} catch (_error) {
		console.info(`catch error in function errorUpdateUI: ${_error}`)
	}
}

export function unfilledSureyPost(myObj: MyObjProp, confirmationUrl: string, cleanUrl: string, testCase: boolean) {
	return new Promise<string>((resolve, _) => {
		($('#mobile-header-timer-seating-chart') as any).TimeCircles().destroy()

		cloneSurvey()

		$('#survey-hidden-order-number').val(myObj.orderId)
		// resultOrderEid = myObj.order
		resolve(cleanUrl)
	}).then(
		(value) => {
			// fulfillment
			const isOldIe = ieDetect().name === 'Explorer'
			if (!testCase) {
				window.location.href = value
			}

			window.unfinishedSurvey = true
		},
		(error) => {
			// rejection
			console.info(`unfilledSureyPost place order rejection: ${error}`)
		}
	)
}

export function prePost() {
	return new Promise<void>((resolve, _) => {
		setShippingBillingValidationRules()
		setCookie('promptMoreTimeValue', '', 1, '')
		resolve()
	})
}

export function prePlaceOrderSubmit() {
	return new Promise<void>((resolve, reject) => {
		if (!window.koStore) {
			if (!($('#order-payment-form') as any).valid()) {
				postAjaxValidationErrors()
				__sendVisit()
				reject('#order-payment-form is not valid')
			} else {
				if (window.enableExitIntend && getCookie('viewedOuibounceModal') == '') {
					disableOuibounceForNormal()
				}
				if ((typeof window.stripeGeneratePaymentIntent === 'function' || typeof window.paypalSubmitCardField === 'function') && window.isCardEmpty) {
					let displayError = document.getElementById('card-errors')
					if (displayError) {
						if (!displayError.textContent) {
							displayError.textContent = 'Please fill in your card details.'
						}
						$('html, body').animate({
							scrollTop: $("#card-element").offset().top
						}, 600);
						return
					}
				}
				// btnLoadingStart('#button-place-order')
				resolve()
			}
		} else {
			if (!($('#order-payment-form') as any).valid()) {
				postAjaxValidationErrors()
				__sendVisit()
				reject('#order-payment-form is not valid')
			} else {
				 if (window.enableExitIntend && getCookie('viewedOuibounceModal') == '') {
					disableOuibounceForNormal()
				}
				resolve()
			}
		}
	})
}

function postAjaxValidationErrors() {
	const errorElement = $('#order-payment-form').find(
		'.has-error em.error'
	)
	var errorText = ""
	errorElement.each(function(index: number, element: HTMLElement) {
    errorText += $(element).text() + "; "
	})
	const resolution = window.displayResolution()
	const postData = {
		errors: errorText,
		paymentMethodId: $('#paymentMethodId').val(),
		orderCheckSum: $('input[name="orderChecksum"]').val(),
		browser: window.BrowserDetect.browser,
		browserVersion: window.BrowserDetect.version,
		os: window.getOS(),
		orientation: window.getOrientation(),
		resolutionWidth: resolution.width,
		resolutionHeight: resolution.height,
	}
	$.ajax({
		method: 'POST',
		url: '/store/order/validation-error',
		data: JSON.stringify(postData),
		dataType: 'json',
	})
}

function clearAllCookies() {
	var cookies = document.cookie.split("; ");
	for (var c = 0; c < cookies.length; c++) {
		var d = window.location.hostname.split(".");
		while (d.length > 0) {
			var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
			var p = location.pathname.split('/');
			document.cookie = cookieBase + '/';
			while (p.length > 0) {
				document.cookie = cookieBase + p.join('/');
				p.pop();
			};
			d.shift();
		}
	}
}


export function postOnSuccess(
	resolve: any,
	reject: any,
	data: any,
	domainName: string,
	testCase: boolean
) {
	const myObj = eval(data)

	if (myObj.gatewayRedirectUrl !== undefined) {
		// send costomer to 3d creditcard validation url returned from gateway
		window.location.href = myObj.gatewayRedirectUrl
		reject('Continue Payment Processing')
	} else if (myObj.status === 1) {
		const _confirmationUrl = myObj.url ? myObj.url : ''
		// const cleanUrl = _confirmationUrl.split(domainName)[1]
		const urlParams = new URL(_confirmationUrl)
		// urlParams.searchParams.set('uitheme', '1')

		// stopCountDown()

		if (!testCase) {
			window.location.href = urlParams.href
		}

		resolve(urlParams)
	} else if (myObj.status === 4) {
		errorUpdateUIScalp(myObj)
		__sendVisit({
			value: 'transaction',
			subCategory: 'transaction',
			label: 'error',
		})
		reject()
	} else if (myObj.status === 5) {
		// __sendVisit({
		// 	value: 'transaction',
		// 	subCategory: 'emailblackList',
		// 	label: 'error',
		// })
		// showLoadingModal()
		// clearAllCookies()
		// setTimeout(() => {
		// 	const str1 = "Your seats are secured, please wait while your payment is being processed."
		// 	Swal.fire(swalOption(str1, true, true))
		// 	setTimeout(() => {
		// 		hideLoadingModal()
		// 		const str2 = "Sorry, the seats you selected are no longer available. Please try again. (Ref. code: SEDB)"
		// 		Swal.fire(swalOption(str2, true, true)).then((result) => {
		// 			window.location.href = '/'
		// 		})
		// 		reject()
		// 	}, 90000);
		// }, 30000);
		emailBlackListModal(reject)
	} else {
		errorUpdateUI(myObj)
		__sendVisit({
			value: 'transaction',
			subCategory: 'transaction',
			label: 'error',
		})
		reject()
	}
}

export function emailBlackListModal(reject?: any) {
	__sendVisit({
		value: 'transaction',
		subCategory: 'emailblackList',
		label: 'error',
	})
	showLoadingModal()
	clearAllCookies()
	setTimeout(() => {
		const str1 = "Your seats are secured, please wait while your payment is being processed."
		Swal.fire(swalOption(str1, true, true))
		setTimeout(() => {
			hideLoadingModal()
			const str2 = "Sorry, the seats you selected are no longer available. Please try again. (Ref. code: SEDB)"
			Swal.fire(swalOption(str2, true, true)).then((result) => {
				window.location.href = '/'
			})
			if (reject) reject()
		}, 90000);
	}, 30000);
}

export function placeOrderPost(testCase: boolean, callerParams?: { error: string }, postUrl?: string) {
	// https://stackoverflow.com/questions/7297833/how-long-will-the-browser-wait-after-an-ajax-request
	let orderId: string
	let eventId: string
	let orderValueTier: string
	let priceTier: string
	return new Promise<string>((resolve, reject) => {
		const formData = new FormData(document.querySelector('#order-payment-form'));
		if (document.querySelector<HTMLInputElement>('input[name="phone"]') && window.iti) {
			formData.set('phone', window.iti.getNumber("INTERNATIONAL"));
		}
		if (document.querySelector<HTMLInputElement>('input[name="phoneBilling"]') && window.itiBilling) {
			formData.set('phoneBilling', window.itiBilling.getNumber("INTERNATIONAL"));
		}
		const textEntries = Array.from(formData.entries()).map(([key, value]) => {
			return [key, typeof value === "string" ? value : value.name];
		});
		let orderPaymentForm = new URLSearchParams(textEntries).toString();

		if (callerParams !== undefined && callerParams !== null) {
			if (callerParams.error !== undefined && callerParams.error !== null) {
				// @ts-ignore
				btnLoadingDone('#button-place-order')

				$('#stripe-msg-holder')
					.find('.error-msg-holder')
					.html(callerParams.error)
				// @ts-ignore
				$('#stripe-msg-holder').modal('show')
				// @ts-ignore
				reject(callerParams.error)
				return true;
			}

			orderPaymentForm = orderPaymentForm + '&' + $.param(callerParams)
		}

		if (postUrl === undefined || postUrl === null) {
			postUrl = '/store/order/fast-payment'
		}

		const countryData = window.iti ? window.iti.getSelectedCountry() : { dialCode: '', iso2: '' };
		const countryDataBilling = window.itiBilling ? window.itiBilling.getSelectedCountry() : { dialCode: '', iso2: '' };


		const domainName = location.host
		const extraData = window.koStore ? prepareKoNamePost() : ''
		const postData = detectMobileWidth()
			? `${orderPaymentForm}${extraData}&place-your-order=1&ajax=1&phoneCountryCode=${encodeURIComponent(countryData.dialCode)}&phoneCountryCodeBilling=${encodeURIComponent(countryDataBilling.dialCode)}&phoneCountryIso=${encodeURIComponent(countryData.iso2)}&phoneCountryIsoBilling=${encodeURIComponent(countryDataBilling.iso2)}`
			: `${orderPaymentForm}${extraData}&ajax=1&phoneCountryCode=${encodeURIComponent(countryData.dialCode)}&phoneCountryCodeBilling=${encodeURIComponent(countryDataBilling.dialCode)}&phoneCountryIso=${encodeURIComponent(countryData.iso2)}&phoneCountryIsoBilling=${encodeURIComponent(countryDataBilling.iso2)}`

		$.ajax({
			url: postUrl,
			type: 'POST',
			data: postData,
			dataType: 'json',
			timeout: 60000, // Set your timeout value in milliseconds or 0 for unlimited
			success: (data, textStatus, xhr) => {
				orderId = 'llMEE-' + data.order
				eventId = data.event
				orderValueTier = data.orderValueTier
				priceTier = data.priceTier
				postOnSuccess(
					resolve,
					reject,
					data,
					// textStatus,
					// xhr,
					// orderPaymentForm,
					domainName,
					testCase
				)
				// resolve()
			},
			error: (jqXHR, textStatus, errorThrown) => {
				if (textStatus === 'timeout') {
					__sendVisit({
						subCategory: 'transaction',
						label: 'sysError',
						value: 'transaction timeout',
					})

					Swal.fire(swalOption(window.myvars.timeoutErrorAfterPlaceOrder)).then(
						() => {
							reject(`timeout: ${errorThrown}`)
							// window.location.reload(true)
						}
					)
				} else {
					__sendVisit({
						subCategory: 'transaction',
						label: 'sysError',
						value: 'transaction server error',
					})
					// alert(myvars.serverError) // Handle other error type
					// saveInfoToCookie()
					Swal.fire(swalOption(window.myvars.serverError)).then((result) => {
						if (result.value) {
							window.location.reload()
						} else {
							Swal.fire(swalOption(errorThrown))
							reject(`placeOrderPost rejection by: ${errorThrown}`)
						}
					})
				}
			},
		})
	}).then(
		(successURL) => {
			// fulfillment
			// console.log('ajax done: ' + successURL)
			if (orderId) {
				window.dataLayer.push({ orderId })
				window.dataLayer.push({ eventId })
				window.dataLayer.push({ orderValueTier })
				window.dataLayer.push({ priceTier })
			}

			if (testCase) $('body').attr('data-confirmation-page', successURL)
		},
		(failed) => {
			// rejection
			// $('#stripe-msg-holder').modal('show')
			btnLoadingDone('#button-place-order')
			console.info(failed)
		}
	)
}

export function _placeOrderPost() {
	return new Promise<void>((resolve, _) => {
		if (typeof window.stripeGeneratePaymentIntent === 'function') {
			// Stripe Paymentment Intent
			window.stripeGeneratePaymentIntent(placeOrderPost)
		} else if (typeof window.gmoGenerateToken === 'function') {
			// GMO for Japan Payment
			window.gmoGenerateToken()
		} else if (typeof window.paygentGenerateToken === 'function') {
			// Paygent for Japan Payment
			saveInfoToCookie()
			window.paygentGenerateToken()
		} else if (typeof window.ewayEncrypt === 'function') {
			// Eway for Australian payment
			window.ewayEncrypt(placeOrderPost)
		} else if (typeof window.inipayMobilePay === 'function') {
			// Korean INIPay Mobile
			window.inipayMobilePay(placeOrderPost)
		} else if (typeof window.inipayDesktopPay === 'function') {
			// Korean INIPay Desktop
			window.inipayDesktopPay(placeOrderPost)
		} else if (typeof window.razorPay === 'function') {
			// India razorpay
			window.razorPay(placeOrderPost)
		} else if (typeof window.pelecardPay === 'function') {
			// Israel Pelecard Pay
			window.pelecardPay(placeOrderPost)
		} else if (typeof window.cieloPayment === 'function') {
			// Brazil Cielo Pay
			window.cieloPayment(placeOrderPost)
		} else if (typeof window.paypalSubmitCardField === 'function') {
			// PayPal Submit Card Field
			window.paypalSubmitCardField(placeOrderPost)
		} else {
			placeOrderPost(false)
		}

		resolve()
	})
}

export async function placeOrder() {
	try {
		await prePost()
		await prePlaceOrderSubmit()

		if ($('.acceptPolicy').is(':checked')) {
			await btnLoadingStart('#button-place-order')
			stopCountDown()
			_placeOrderPost()
		} else {
			// @ts-ignore
			// await btnLoadingDone('#button-place-order')
			// @ts-ignore
			$('#term-msg-holder').modal('show')
			// alert('hi2')
			__sendVisit({
				value: 'policy',
				label: 'error',
			})
		}
	} catch (error) {
		btnLoadingDone('#button-place-order')
		// const errorElement = $('#order-payment-form-left').find('.error')
		// await frontendErrorToShow(errorElement)
		// await errorModal()
		__sendVisit({
			value: 'formerror',
			label: 'error',
		})
		console.info(error)
	}
}

// export function placeOrder() {
// 	if ($('.acceptPolicy').is(':checked')) {
// 		_placeOrder()
// 	} else {
// 		// alert(dataPolicyAlert)
// 		($('#term-msg-holder') as any).modal('show')

// 		__sendVisit({
// 			value: 'policy',
// 			label: 'error',
// 		})
// 	}
// }

window.prepareKoNamePost = prepareKoNamePost
window.emailBlackListModal = emailBlackListModal
window.errorUpdateUIScalp = errorUpdateUIScalp